import { createSelector } from '@reduxjs/toolkit';

import { AppState } from '@modules';

export const countriesSelector = createSelector(
  (state: AppState) => state.global.countries,
  countries => countries.map(({ code, title }) => ({ value: code, label: title }))
);
